// extracted by mini-css-extract-plugin
module.exports = {"actions-cnt":"GenericActionsPopover_actions-cnt__2xij7","actions-option-cnt":"GenericActionsPopover_actions-option-cnt__1jgxL"};